import React, { useMemo } from 'react';
import { Box, Typography, Card, CardMedia, CardContent } from '@mui/material';
import { useDashboard } from '../../../contexts/DashboardContext';

export default function DashboardImage({ panelId, outputKey = 'image_url', config }) {
  const { getSlice } = useDashboard();
  const raw = getSlice(panelId, outputKey);

  const { url, alt, title, description } = useMemo(() => {
    if (!raw) return { url: null, alt: '', title: '', description: '' };
    if (typeof raw === 'string') return { url: raw, alt: '', title: '', description: '' };
    if (typeof raw === 'object') {
      return {
        url: raw.url || raw.image_url || raw.src || null,
        alt: raw.alt || raw.title || '',
        title: raw.title || '',
        description: raw.description || raw.caption || '',
      };
    }
    return { url: null, alt: '', title: '', description: '' };
  }, [raw]);

  if (!url) {
    return (
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: 200 }}>
        <Typography color="text.secondary">No image URL. Use chat to run a flow.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Card sx={{ maxWidth: '100%', maxHeight: '100%' }}>
        <CardMedia
          component="img"
          image={url}
          alt={alt || title}
          sx={{ maxHeight: '70vh', objectFit: 'contain' }}
        />
        {(title || description) && (
          <CardContent>
            {title && <Typography variant="h6">{title}</Typography>}
            {description && <Typography variant="body2" color="text.secondary">{description}</Typography>}
          </CardContent>
        )}
      </Card>
    </Box>
  );
}
